import { render, staticRenderFns } from "./clientInformation.vue?vue&type=template&id=26836b7b&scoped=true"
import script from "./clientInformation.vue?vue&type=script&lang=js"
export * from "./clientInformation.vue?vue&type=script&lang=js"
import style0 from "./clientInformation.vue?vue&type=style&index=0&id=26836b7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26836b7b",
  null
  
)

export default component.exports